<template lang="pug">
.preview-iphone-notification
  v-card.round-xl.background.pa-2(outlined width="320px")
    v-row(no-gutters align="center")
      v-col.mr-3
        .white.round-xl
          v-icon(size="35") $yzi-gmail-icon
      v-col.text-left.pr-2(cols="8")
        .text-sm.text-semibold.white--text(v-if="title") {{ title }}
        .text-xs.white--text(v-if="content") {{ content }}
      v-col(cols="2" align-self="start")
        .text-xs.basic500--text {{ elapsed }} ago
</template>

<script>
import PreviewIphoneHomeBar from '@/components/review/preview/PreviewIphoneHomeBar.vue'

export default {
  name: 'PreviewIphoneNotification',
  components: {
    PreviewIphoneHomeBar
  },
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    elapsed: {
      type: String,
      default: '30m'
    }
  }
}
</script>

<style scoped>
.background {
  border: none;
  background-color: rgba(37, 37, 37, 0.5);
}
</style>